import React, { useState } from 'react';

import {
  Form,
  FormItem,
  SubmitButton,
  Button,
  Input,
} from '../../../../../components';
import { validateChunkValue } from '../../../../../components/AgentForm/utils/validators';

const DEFAULT_CHUNK_SIZE = 2500;
const DEFAULT_CHUNK_OVERLAP = 250;
const MAX_CHUNK_SIZE = 10000;
const MAX_CHUNK_OVERLAP = 1000;
const MIN_CHUNK_VALUE = 0;

export type FormProps = {
  chunkSize: number;
  chunkOverlap: number;
};
type VectorizeFormProps = {
  saving: boolean;
  onCancel: () => void;
  onSave: (data: any) => void;
  isEditMode?: boolean;
};

const VectorizeSourceForm: React.FC<VectorizeFormProps> = ({
  saving,
  onSave,
  onCancel,
  isEditMode = false,
}) => {
  const [values, setValues] = useState<FormProps>({
    chunkSize: DEFAULT_CHUNK_SIZE,
    chunkOverlap: DEFAULT_CHUNK_OVERLAP,
  });

  return (
    <div className="flex flex-col gap-y-12 w-full">
      <Form onChange={setValues} initialValue={values}>
        <FormItem<FormProps>
          required
          name="chunkSize"
          label={'Chunk Size'}
          inline={false}
          validate={validateChunkValue({
            min: MIN_CHUNK_VALUE,
            max: MAX_CHUNK_SIZE,
            otherFieldName: 'chunkOverlap',
            errorMessage: 'Chunk size cannot be less than chunk overlap',
            comparison: 'lessThan',
          })}
        >
          <Input />
        </FormItem>
        <FormItem<FormProps>
          required
          name="chunkOverlap"
          label={'Chunk Overlap'}
          inline={false}
          validate={validateChunkValue({
            min: MIN_CHUNK_VALUE,
            max: MAX_CHUNK_OVERLAP,
            otherFieldName: 'chunkSize',
            errorMessage: 'Chunk overlap cannot be greater than chunk size',
            comparison: 'greaterThan',
          })}
        >
          <Input />
        </FormItem>

        <div className="flex flex-col gap-y-md justify-center items-center">
          <SubmitButton
            size="medium"
            disabled={saving}
            className="w-full"
            label="Activate"
            loading={saving}
            onClick={() =>
              onSave({
                chunkSize: values.chunkSize,
                chunkOverlap: values.chunkOverlap,
              })
            }
          />
          <Button
            size="medium"
            type="contrast"
            label="Cancel"
            className="w-full text-main"
            onClick={onCancel}
          />
        </div>
      </Form>
    </div>
  );
};

export default VectorizeSourceForm;
